"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var recoil_1 = require("recoil");
var store_1 = require("@/store");
var TOAST_DURATION = 3000;
var toastTimeout;
var useToast = function () {
    var _a = __read((0, recoil_1.useRecoilState)(store_1.$toast), 2), toast = _a[0], setToast = _a[1];
    var handleRemoveToast = function () {
        if (toastTimeout) {
            clearTimeout(toastTimeout);
        }
        setToast(undefined);
    };
    var handleAddToast = function (newToast) {
        if (toast) {
            handleRemoveToast();
        }
        setToast(__assign({}, newToast));
        toastTimeout = setTimeout(function () {
            setToast(undefined);
        }, TOAST_DURATION);
    };
    return {
        handleAddToast: handleAddToast,
        handleRemoveToast: handleRemoveToast,
    };
};
exports.default = useToast;
